import { render, staticRenderFns } from "./personSelectNew.vue?vue&type=template&id=3d8eee7f&"
import script from "./personSelectNew.vue?vue&type=script&lang=js&"
export * from "./personSelectNew.vue?vue&type=script&lang=js&"
import style0 from "./personSelectNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports